import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

export const profileValidator = withZod(
  z.object({
    name: z.string().min(1, { message: `Name is required` }),
    email: z.string().trim().min(5, { message: `Email is required` }).email(`Must be a valid email`),
  }),
) as any
